module.exports = __webpack_public_path__ + "img/aitu-color.98c84d22.svg";